import { render, staticRenderFns } from "./ViewWebsite.vue?vue&type=template&id=0aa0e2cf&scoped=true&"
import script from "./ViewWebsite.vue?vue&type=script&lang=ts&"
export * from "./ViewWebsite.vue?vue&type=script&lang=ts&"
import style0 from "./ViewWebsite.vue?vue&type=style&index=0&id=0aa0e2cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa0e2cf",
  null
  
)

export default component.exports